import ReactDOM from 'react-dom/client';
import microApp from '@micro-zoe/micro-app';
import './i18n/init';
import App from './App';
import './global.scss';
import './styles/antd/replace.scss';

const env = process.env.REACT_APP_ENV as 'dev' | 'test' | 'pre' | 'prod';
const baseUrl =
    {
        pre: 'https://pre-option-s.theckb.com/',
        prod: 'https://option-s.theckb.com/'
    }[env] ?? 'https://master-option-s.theckb.com/';
microApp.start({
    'router-mode': 'pure',
    tagName: 'micro-app-addition',
    preFetchApps: [
        {
            name: 'AdtOrder',
            url: `${baseUrl}orderAddition`
        },
        {
            name: 'DeliAdt',
            url: `${baseUrl}deliverAddition`
        }
    ]
});
const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(<App />);
